import { compact, present } from '@art-suite/art-core-ts';

export const stripLeadingAndTrailingSlashes = <T extends string | null | undefined>(path: T): T => {
  const stripped = path?.replace(/^\/|\/$/g, '');
  return present(stripped) ? stripped as T : undefined as T;
};

export const stripLeadingSlash = (a: string) => a.replace(/^\//, '');
export const stripTrailingSlash = (a: string) => a.replace(/\/$/, '');

export const urlJoin = (apiUrl: string | null | undefined, path: string) => apiUrl ? joinUrlParts([apiUrl, path], '/') : path;

export const joinUrlParts = (parts: (string | null | undefined)[], separator: string = '/') =>
  compact(parts.map(stripLeadingAndTrailingSlashes)).join(separator);
export const getAbsoluteRoutePath = (parts: (string | null | undefined)[], separator: string = '/') => '/' + joinUrlParts(parts, separator);
